import { populateZmanimTable } from '../shared/zmanim-shabbos.js';
import { showAlertMsg } from './member-show-alert-msg.js';

const OPTIONS_KEY = 'zmanimOptions';
const INIT_KEY = 'zmanimModalInit';

export function closeZmanim() {
    $('#zmanimModal').modal('hide');
}

export function openZmanim() {
    initZmanimModal();
    const $modal = $('#zmanimModal');
    if (!$modal.length) {
        throw new Error('openZmanim: #zmanimModal is missing from the DOM');
    }
    const options = $modal.data(OPTIONS_KEY);
    if (!options) {
        throw new Error('openZmanim: zmanim modal has not been initialized yet');
    }
    const table = $modal.find('.zmanim-content table').get(0);
    if (!table) {
        throw new Error('openZmanim: zmanim table is missing from the modal');
    }
    try {
        populateZmanimTable(table, options);
    } catch (error) {
        showAlertMsg(error instanceof Error ? error.message : String(error), 'danger');
        return;
    }
    $modal.modal('show');
}

export function initZmanimModal() {
    const EVT_NS = '.zmanimModal';
    const DISMISS_NS = 'mousedown.zmanimModalDismiss keydown.zmanimModalDismiss';

    function readConfig($root) {
        const el = $root[0];
        return {
            timeZoneId: el.dataset.timeZone || '',
            latitude: Number.parseFloat(el.dataset.latitude),
            longitude: Number.parseFloat(el.dataset.longitude),
            elevation: Number.parseFloat(el.dataset.elevation),
            shabbosWord: el.dataset.shabbosWord || 'Shabbos',
        };
    }

    function syncOptions($modal, config, date) {
        $modal.data(OPTIONS_KEY, {
            timeZoneId: config.timeZoneId,
            latitude: config.latitude,
            longitude: config.longitude,
            elevation: config.elevation,
            complexZmanim: true,
            date: date,
        });
    }

    function normalizeDay(d) {
        const x = new Date(d);
        x.setHours(12, 0, 0, 0);
        return x;
    }

    function formatToolbarDate(date, shabbosWord) {
        return date
            .toLocaleDateString('en-us', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            })
            .replace('Saturday', shabbosWord);
    }

    function initZmanimModalOnce() {
        const $modal = $('#zmanimModal');
        if (!$modal.length || $modal.data(INIT_KEY)) {
            return;
        }
        $modal.data(INIT_KEY, true);

        const config = readConfig($modal);
        let selectedDay = normalizeDay(new Date());
        syncOptions($modal, config, selectedDay);

        const $datepicker = $modal.find('#zmanim-datepicker');
        const $popover = $modal.find('#zmanim-datepicker-popover');
        const $calendar = $modal.find('#calendar');
        const $dateDisplay = $modal.find('#date-display');
        const popoverEl = $popover[0];
        const calendarEl = $calendar[0];

        let programSync = false;

        function unbindDismiss() {
            $(document).off(DISMISS_NS);
        }

        function closeDatePopover() {
            $popover.addClass('d-none').attr('aria-hidden', 'true');
            $calendar.attr('aria-expanded', 'false');
            unbindDismiss();
        }

        function bindDismiss() {
            unbindDismiss();
            $(document).on(DISMISS_NS, function (ev) {
                if (ev.type === 'keydown' && ev.key !== 'Escape') {
                    return;
                }
                const t = ev.target;
                const insidePopover = popoverEl && popoverEl.contains(t);
                const insideCalendarBtn = calendarEl && calendarEl.contains(t);
                if (insidePopover || insideCalendarBtn) {
                    return;
                }
                closeDatePopover();
            });
        }

        function updateDateDisplay(date, openZmanimOnUpdate = true) {
            selectedDay = normalizeDay(date);
            syncOptions($modal, config, selectedDay);
            $dateDisplay.text(formatToolbarDate(selectedDay, config.shabbosWord));
            if ($datepicker.data('datepicker')) {
                programSync = true;
                $datepicker.datepicker('setDate', selectedDay);
                programSync = false;
            }
            if (openZmanimOnUpdate) {
                openZmanim();
            }
        }

        function onPickerChangeDate(e) {
            const pickedDate = e.date || (e.originalEvent && e.originalEvent.date);
            if (programSync || !pickedDate) {
                return;
            }
            updateDateDisplay(pickedDate);
            closeDatePopover();
        }

        function mountDatepickerWhenVisible() {
            if ($datepicker.data('datepicker')) {
                programSync = true;
                $datepicker.datepicker('setDate', selectedDay);
                programSync = false;
                return;
            }
            $datepicker
                .datepicker({
                    todayHighlight: true,
                    autoclose: true,
                    templates: {
                        leftArrow: '<i class="fa-light fa-chevron-left"></i>',
                        rightArrow: '<i class="fa-light fa-chevron-right"></i>',
                    },
                })
                .on('changeDate', onPickerChangeDate);
            programSync = true;
            $datepicker.datepicker('setDate', selectedDay);
            programSync = false;
        }

        function openDatePopover() {
            $popover.removeClass('d-none').attr('aria-hidden', 'false');
            $calendar.attr('aria-expanded', 'true');
            bindDismiss();
            window.requestAnimationFrame(function () {
                mountDatepickerWhenVisible();
            });
        }

        function shiftByDays(delta) {
            const next = new Date(selectedDay);
            next.setDate(next.getDate() + delta);
            updateDateDisplay(next);
        }

        updateDateDisplay(selectedDay, false);

        $modal.find('#prev-btn').off('click' + EVT_NS).on('click' + EVT_NS, function () {
            shiftByDays(-1);
        });

        $modal.find('#next-btn').off('click' + EVT_NS).on('click' + EVT_NS, function () {
            shiftByDays(1);
        });

        $calendar.off('click' + EVT_NS).on('click' + EVT_NS, function (e) {
            e.stopPropagation();
            if ($popover.hasClass('d-none')) {
                openDatePopover();
            } else {
                closeDatePopover();
            }
        });

        $modal.off('hidden.bs.modal' + EVT_NS).on('hidden.bs.modal' + EVT_NS, function () {
            closeDatePopover();
            if ($datepicker.data('datepicker')) {
                $datepicker.datepicker('destroy');
            }
        });
    }

    initZmanimModalOnce();
    $(document).off('shown.bs.modal' + EVT_NS, '#zmanimModal').on('shown.bs.modal' + EVT_NS, '#zmanimModal', initZmanimModalOnce);
}
